import Allowlists from "./allowlists";

export default Allowlists;